import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';

import {ThemeProvider} from "@mui/material";
import dayjs, {Dayjs} from "dayjs";

import {FC} from "react";
import {newTheme} from "../../../pages/landing/SignUp2_Talent/components/components.utils";

interface MaterialCalendarPickerProps {
    format?: string;
    label: string;
    defaultValue?: Dayjs | null;
    value?: Dayjs | null;
    onChange?: (date: Dayjs | null) => void;
    error?: string;
    views?: ('day' | 'month' | 'year')[];
    name: string;
    disabled?: boolean;
    className?: string;
}

const MaterialCalendarPicker: FC<MaterialCalendarPickerProps> = (
    {
        format = 'LL',
        label,
        defaultValue,
        value,
        onChange,
        error,
        views,
        disabled,
        className,
    }: MaterialCalendarPickerProps) => {
    const [open, setOpen] = React.useState(false);

    const formatedViews = views?.filter((value, index, array) => array.indexOf(value) === index);

    return (
        <ThemeProvider theme={newTheme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    className={className}
                    format={format}
                    disabled={disabled}
                    label={label}
                    defaultValue={defaultValue ? dayjs(defaultValue) : null}
                    value={value ? dayjs(value) : null}
                    onChange={onChange}
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    slotProps={{
                        day: {
                            sx: {
                                "&.MuiPickersDay-root.Mui-selected": {
                                    backgroundColor: '#FB7672',
                                },
                            },
                        },
                        textField: {
                            className: 'fakeDisabled',
                            disabled: true,
                            onClick: () => setOpen(true),
                            error: !!error,
                            helperText: error,
                            color: error ? 'warning' : undefined,
                            sx: {
                                '& .Mui-disabled': {
                                    color: error ? 'rgb(211, 47, 47) !important' : undefined,
                                    cursor: 'pointer !important',
                                    WebkitTextFillColor: error ? 'rgb(211, 47, 47) !important' : undefined,
                                },
                            },
                        },
                    }}
                    views={formatedViews?.length ? [...formatedViews] : undefined}
                />
            </LocalizationProvider>
        </ThemeProvider>
    );
}

export default MaterialCalendarPicker;
